export default "__VITE_ASSET__B2MX4cwu__"